import React, { useRef } from "react";
import { Printer } from "lucide-react";

const FinalLandAllotmentLetter = ({ setSubComponent }) => {
    const printRef = useRef(null);

    const handleFinalLandLetter = () => {
        setSubComponent("FinalListofPlot");
    };
    const handleFinalLandRemarks= () => {
        setSubComponent("FinalLand");
    };
    const handleFinalLandList = () => {
        setSubComponent("FinalLandAllotmentList");
    };

    return (
        <div className="p-6 bg-gray-100">
            {/* PRINT BUTTON */}
            <div className="flex justify-start mb-4 gap-2">
                <button
                    onClick={handleFinalLandList}
                    className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
                >
                    अंतिम यादी
                </button>

                <button
                    onClick={handleFinalLandRemarks}
                    className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
                >
                    अंतिम प्रसिद्धी अहवाल
                </button>
                <button
                    onClick={handleFinalLandLetter}
                    className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
                >
                    अंतिम टिप्पणी
                </button>


            </div>

           
        </div>
    );
};

export default FinalLandAllotmentLetter;
